import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import Delay from "~/ts/library/Delay";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";

export default class OperatorTyping extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "operator_typing";
    }

    public async receive(payload: CometOperatorApplication.OperatorTypingCometMessageOpenApiModel) {
        let access = true;

        if (payload.operator != OperatorAccountStore.login.value) {
            if (!OperatorAccountStore.data.value.accessRights.canViewChatsWithOtherOperators) {
                access = !!getCurrentDialogOfClient(
                    ClientUserdataStore.getByUsername(payload.username, false)
                )?.isOperatorInDialog;
            }
            if (access) {
                if (typeof payload.text == "string" && !payload.text.length) {
                    payload.text = null;
                }
                let eventName = OperatorTyping.getEventNameByUsername(payload.username);
                OperatorApplicationEventManager.emit(eventName, payload);
                try {
                    await Delay.make(10000, eventName, true);
                    OperatorTyping.clear(payload.username, payload.operator);
                } catch (e) {

                }
            }
        }
    }

    public static getEventNameByUsername(username: string): string {
        return `OperatorTyping_${username}`;
    }

    public static clear(username: string, operator: string) {
        let newPayload: CometOperatorApplication.OperatorTypingCometMessageOpenApiModel = {
            username,
            operator,
            text: null,
            action: "operator_typing"
        };
        newPayload.text = null;
        OperatorApplicationEventManager.emit(
            this.getEventNameByUsername(username),
            newPayload
        );
    }

}